var render = function render(_c,_vm){return _c('div',{staticClass:"search-badge tw-flex tw-justify-center tw-items-center tw-ml-4"},[_c('i',{staticClass:"far",class:[{'fa-crown': _vm.props.admin},{'fa-cog': _vm.props.moderator}]}),_c('span',[_vm._v(_vm._s(_vm.props.admin ? 'Admin' : 'Moderator'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }